<menu class="accordion nav-menu" id="navigationMenu">
  <section class="accordion-item nav-menu__section">
    <h2 class="accordion-header" id="infoHeading">
      <button
        class="accordion-button collapsed nav-menu__section-button"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#infoMenuRoutes"
        aria-expanded="false"
        aria-controls="infoMenuRoutes">
        <strong>{{ 'shared.header.navigation.about-us' | translate }}</strong>
      </button>
    </h2>
    <div id="infoMenuRoutes" class="accordion-collapse collapse" aria-labelledby="infoHeading" data-bs-parent="#navigationMenu">
      <ul class="accordion-body nav-menu__section-group" aria-labelledby="infoMenuRoutes">
        <li class="nav-menu__section-group-item">
          <a routerLink="/organization">
            {{ 'shared.header.navigation.organization' | translate }}
          </a>
        </li>
        <li class="nav-menu__section-group-item">
          <a routerLink="/contact">
            {{ 'shared.header.navigation.contact' | translate }}
          </a>
        </li>
        <!-- <li class="nav-menu__section-group-item">
          <a routerLink="/rules">
            {{ 'shared.header.navigation.rules' | translate }}
            </a>
        </li> -->
        <li class="nav-menu__section-group-item">
          <a routerLink="/faq">
            {{ 'shared.header.navigation.faq' | translate }}
          </a>
        </li>
      </ul>
    </div>
  </section>

  <section class="accordion-item nav-menu__section">
    <h2 class="accordion-header" id="eventHeading">
      <button
        class="accordion-button collapsed nav-menu__section-button"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#eventMenuRoutes"
        aria-expanded="false"
        aria-controls="eventMenuRoutes">
        <strong>{{ 'shared.header.navigation.event' | translate }}</strong>
      </button>
    </h2>
    <div id="eventMenuRoutes" class="accordion-collapse collapse" aria-labelledby="eventHeading" data-bs-parent="#navigationMenu">
      <ul class="accordion-body nav-menu__section-group" aria-labelledby="eventMenuRoutes">
        <li class="nav-menu__section-group-item">
          <a routerLink="/event/tickets">
            {{ 'shared.header.navigation.tickets' | translate }}
          </a>
        </li>
        <li class="nav-menu__section-group-item">
          <a routerLink="/event/hotel">
            {{ 'shared.header.navigation.hotel' | translate }}
          </a>
        </li>
        <li class="nav-menu__section-group-item disabled-link">
          <a routerLink="/event/activities">
            {{ 'shared.header.navigation.activities' | translate }}
          </a>
        </li>
        <li class="nav-menu__section-group-item">
          <a routerLink="/event/convention-center">
            {{ 'shared.header.navigation.conventionCenter' | translate }}
          </a>
        </li>
        <li class="nav-menu__section-group-item">
          <a routerLink="/event/dealers-den">
            {{ 'shared.header.navigation.dealers-den' | translate }}
          </a>
        </li>
        <li class="nav-menu__section-group-item">
          <a routerLink="/event/artist-alley">
            {{ 'shared.header.navigation.artist-alley' | translate }}
          </a>
        </li>
      </ul>
    </div>
  </section>

  <!-- <div class="accordion-item nav-menu__section">
    <button class="btn btn-block nav-menu__section-button">
      <a routerLink="/collaborators">
        {{ 'shared.header.navigation.collaborations' | translate }}
      </a>
    </button>
  </div> -->

  <div class="accordion-item nav-menu__section">
    <button routerLink="/volunteer" class="btn btn-block nav-menu__section-button">
      <strong>{{ 'shared.header.navigation.volunteer' | translate }}</strong>
    </button>
  </div>

  <div class="accordion-item nav-menu__section">
    <button routerLink="/status" class="btn btn-block nav-menu__section-button">
      <strong>
        {{ 'shared.header.navigation.status' | translate }}
      </strong>
    </button>
  </div>

  <hr />

  <div class="accordion-item nav-menu__section">
    <app-language-selector class="nav-menu__lang" />
  </div>
</menu>
